/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
    Bar,BarChart,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../utils/helpers';
import { CustomTooltip, refundOrderKey, orderKey } from '../helper';

const ReturnRefundBarChart = ({
    dir, showTitle, categorisedBasedOn, index,
    currentYearMonthDayWise, height, category, currentlyShowType }) => {
    const { t } = useTranslation('common');
    const [color1, color2] = colorsCombination[index % 10];

    const dataToShow = [];
    Object.keys((currentYearMonthDayWise)).forEach((dayMonthYear) => {
        const [day, month, year, dayofyear] = dayMonthYear.split('-');
        const { refundOrderCount, orderCount } = currentYearMonthDayWise?.[dayMonthYear]
            ?.reduce((acc, item) => {
                acc.refundOrderCount = Number(Number(Number(acc.refundOrderCount) + Number(item.refundOrderCount)).toFixed(2));
                acc.orderCount = Number(Number(Number(acc.orderCount) + Number(item.orderCount)).toFixed(2));
                return acc
            }, { refundOrderCount: 0, orderCount: 0 }) ?? { refundOrderCount: 0, orderCount: 0 };

        const currentMonthDataKey = currentlyShowType?.value === 'daily' ? 
        `${day}, ${month} ${year}` : `${day}, ${month}`;

        dataToShow.push({
            [refundOrderKey]: refundOrderCount,
            "day": `${currentMonthDataKey}`,
            currentMonthDataKey,
            category,
            [orderKey]: orderCount
        })
    })
    
    return (
        <Col xs={12}>
            <Card>
                <CardBody>
                    {showTitle ? <div className="card__title">
                        <h5 className="bold-text">{t('comparemonthlysales.compareDays')}</h5>
                    </div> : null}
                    <div dir="ltr">
                        <ResponsiveContainer height={height}>
                            <BarChart
                                data={dataToShow}
                                margin={{
                                    top: 0, right: 0, left: 25, bottom: 0,
                                }}
                            >
                                <XAxis dataKey="day" reversed={dir === 'rtl'} />
                                <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                                    tickFormatter={item => setCurrencyFormat(item, false)}
                                    width={90}
                                    allowDataOverflow
                                />
                                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                                <Tooltip formatter={item => setCurrencyFormat(item, false)} />
                                {/* <Tooltip content={<CustomTooltip category={category} categorisedBasedOn={categorisedBasedOn} />} /> */}
                                <Legend />
                                <Bar stackId="a"  dataKey={orderKey.toString()}
                                        barSize={40} fill={color1 || '#3366ff'} />
                                <Bar stackId="a"  dataKey={refundOrderKey.toString()}
                                        barSize={40} fill={color2 || '#3366ff'} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

ReturnRefundBarChart.propTypes = {
    dir: PropTypes.string.isRequired,
    currentYearMonthDayWise: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    category: PropTypes.string.isRequired,
    categorisedBasedOn: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    currentlyShowType: PropTypes.object.isRequired
};

ReturnRefundBarChart.defaultProps = {
    showTitle: true
}

export default ReturnRefundBarChart;
